import { render, staticRenderFns } from "./bandejaContabilidadSaldo.vue?vue&type=template&id=b62cc6da&scoped=true"
import script from "./bandejaContabilidadSaldo.vue?vue&type=script&lang=js"
export * from "./bandejaContabilidadSaldo.vue?vue&type=script&lang=js"
import style0 from "./bandejaContabilidadSaldo.vue?vue&type=style&index=0&id=b62cc6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62cc6da",
  null
  
)

export default component.exports